import script from "./CurriculumPage02Detail.vue?vue&type=script&setup=true&lang=js"
export * from "./CurriculumPage02Detail.vue?vue&type=script&setup=true&lang=js"

import "./CurriculumPage02Detail.vue?vue&type=style&index=0&id=4bde833a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bde833a"]])

export default __exports__